<template>
	<ul class="nav">
		<li class="nav-profile">
			<a href="javascript:;" v-on:click="expand()">
				<div class="cover with-shadow"></div>
				<div class="image">
					<img src="/app/assets/logo.png" alt="">
				</div>
				<div class="info">
					<b class="caret pull-right"></b>
					{{this.$store.state.usuario.nombres | mayuscula}}
					<small>Administrador</small>
				</div>
			</a>
		</li>
		<li>
			<ul class="nav nav-profile animated fadeIn" v-bind:class="{ 'd-block': this.stat == 'expand' && !this.pageOptions.pageSidebarMinified, 'd-none': this.stat == 'collapse' }">
				<li><a href="javascript:;"><i class="fa fa-cog"></i> Configuración</a></li>
				<li><a href="javascript:;"><i class="fa fa-pencil-alt"></i> Reporte de sistema</a></li>
				<li><a href="javascript:;"><i class="fa fa-question-circle"></i> Helps</a></li>
			</ul>
		</li>
	</ul>
</template>

<script>
import PageOptions from '../../config/PageOptions.vue'

export default {
	name: 'SidebarNavProfile',
	data() {
		return {
			stat: '',
			pageOptions: PageOptions
		}
	},
	methods: {
		expand: function() {
			this.stat = (this.stat == 'expand') ? 'collapse' : 'expand'
		}
  }
}
</script>
